import React from "react";
import { Link } from "react-router-dom";
import logoDark from "../../assets/images/logo hl software ( letra preta ).png";
import logoLight from "../../assets/images/logo hl software ( letra banca ).png";

export default function Logo({ variant = "dark", size = 160 }) {
    const logo = variant === "light" ? logoLight : logoDark;

    return (
        <Link to="/" style={{ display: "inline-block" }}>
            <img
                src={logo}
                alt="HL Software - Transformando ideias em tecnologia"
                width={size}
                height="auto"
                style={{ display: "block" }}
            />
        </Link>
    );
}
